import React, { useRef, useState, useCallback } from "react";
import { FormGroup, Label, Input, Row, Col } from "reactstrap";
import {
    GoogleMap,
    Marker,
    LoadScript,
    Autocomplete,
} from "@react-google-maps/api";

const libraries = ["places"];
const mapContainerStyle = {
    width: "100%",
    height: "300px",
};

const defaultCenter = {
    lat: 33.6844, // Islamabad
    lng: 73.0479,
};

const LocationPicker = ({
    locationData,
    setLocationData,
    label = "Default Address",
    errors
}) => {
    const autocompleteRef = useRef(null);
    const [map, setMap] = useState(null);

    const handlePlaceChanged = () => {
        const place = autocompleteRef.current.getPlace();
        if (place && place.geometry) {
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();
            const address = place.formatted_address || place.name;

            setLocationData({
                location: address,
                latitude: lat,
                longitude: lng,
            });

            if (map) {
                map.panTo({ lat, lng });
            }
        }
    };

    const handleMarkerDragEnd = (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            if (status === "OK" && results[0]) {
                setLocationData({
                    location: results[0].formatted_address,
                    latitude: lat,
                    longitude: lng,
                });
            } else {
                setLocationData({
                    location: "",
                    latitude: lat,
                    longitude: lng,
                });
            }
        });
    };

    const onMapLoad = useCallback((mapInstance) => {
        setMap(mapInstance);
    }, []);

    return (
        <LoadScript
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
            libraries={libraries}
        >
            <div>
                {/* Layout: Left = Coords, Right = Map */}
                <Row>

                    <Col md={4}>
                        <FormGroup>
                            <Label>{label}</Label>
                            <Autocomplete
                                onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
                                onPlaceChanged={handlePlaceChanged}
                            >
                                <Input
                                    type="text"
                                    name="location"
                                    placeholder="Search location..."
                                    defaultValue={locationData.location || ""}
                                    className="form-control"
                                />
                            </Autocomplete>
                        </FormGroup>
                        <FormGroup>
                            <Label>Latitude</Label>
                            <Input
                                type="number"
                                name="latitude"
                                value={locationData.latitude || ""}
                                readOnly
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Longitude</Label>
                            <Input
                                type="number"
                                name="longitude"
                                value={locationData.longitude || ""}
                                readOnly
                            />
                        </FormGroup>
                    </Col>

                    {/* Right Side - Map */}
                    <Col md={8}>
                        <div style={mapContainerStyle}>
                            <GoogleMap
                                mapContainerStyle={{ width: "100%", height: "100%" }}
                                center={
                                    locationData.latitude && locationData.longitude
                                        ? {
                                            lat: locationData.latitude,
                                            lng: locationData.longitude,
                                        }
                                        : defaultCenter
                                }
                                zoom={14}
                                onLoad={onMapLoad}
                            >
                                <Marker
                                    position={{
                                        lat: locationData.latitude || defaultCenter.lat,
                                        lng: locationData.longitude || defaultCenter.lng,
                                    }}
                                    draggable={true}
                                    onDragEnd={handleMarkerDragEnd}
                                />
                            </GoogleMap>
                        </div>
                    </Col>
                </Row>
            </div>
        </LoadScript>
    );
};

export default LocationPicker;
